module.exports = __webpack_public_path__ + "static/img/college1.6e9b452.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/college/college1.jpeg
// module id = 1gNX
// module chunks = 45